

var FALSE = false,
TRUE = true,
TYPE_OBJ = "object",
TYPE_FUNC = "function",
LEN = "length",
TYPE_UNDEF = "undefined",
PROTO = "prototype",

exp = {},
fitt = require("fitt"),
isAry = fitt.isAry,
mix = fitt.mix,
cstr = fitt.cstr,
es = fitt.es,
ues = fitt.ues,
subStr = fitt.subStr,
idxOf = fitt.idxOf,
charAt = fitt.charAt,
keys = fitt.keys,
ParamHashProto = null,
a = "&",
eq = "=",
q = "?";

/**
         * Intantiable class used to convert a delimited string into an object.<br />
         * For example querystrings: "name_1=value_1&name_2=value_2" ==> {name_1:value_1,name_2:value_2};<br/>
         *
         * Note that unescaped property values
         * that are added into this object, that also contain the same sPropDelim and sValueDelim strings will be recursively
         * converted into their own ParamHash objects.  Therefore if you do not want this recursion to occur, you must make sure
         * that the values are encoded/escaped properly.
         *
         * This class basically has 3 major usecases:
         * <ol>
         *  <li>Creation of URL parameters for a query-string, or form-encoded posts</li>
         *  <li>Creation of inline style attribute values</li>
         *  <li>Serialization / deserialization of objects where you do not want to use JSON. In many
         *      cases this object will do such work faster</li>
         * </ol>
         *
         * <b style='color:maroon'>DO NOT PASS IN DOM Nodes to this constructor.  DOM Nodes have cyclical references which will cause never-ending loops</b>
         *
         * @class
         * @name fitt.ParamHash
         * @param {String|Object} sString  The delimited string to be converted, or an object to be converted into a ParamHash.  Objects are basically
         *                                 dealt with by copying the properties that show up into a clone. Note that ALL enumerable properties are copyied (recursively
         *                                 if desired), whether they are inherited via the prototype chain or not (unless bOwned argument is set too true).
         *
         * @param {String} [sPropDelim='&']  The substring delimiter used to separate properties. Default is "&".
         * @param {String} [sValueDelim='=']  The substring delimited used to separate values.  Default is "=".
         * @param {Boolean} [bNoOverwrite=false]  If true, when a name is encountered more than 1 time in the string it will be ignored.
         * @param {Boolean} [bRecurse=false]  If true, when a value of a property that is parsed also has both the sPropDelim
         *                                    and sValueDelim inside, convert that value to another ParamHash object automatically
         * @param {Boolean} [bOwned=false] Only iterate over owned properties if passing in an object to convert into a ParamHash instance.
         */

function ParamHash(sString, sPropDelim, sValueDelim, bNoOverwrite, bRecurse, bOwned)
{
	var doAdd = FALSE,firstChar,idx,idx2,idx3,sTemp,sTemp2,sTemp3,me = this,pairs,nv,nm,added,cnt,obj,len,len2;

	if (!me || !(me instanceof ParamHash)) return new ParamHash(sString, sPropDelim, sValueDelim, bNoOverwrite, bRecurse, bOwned);
	if (!arguments[LEN]) return me;

	if (sString && typeof sString == TYPE_OBJ) return mix(new ParamHash('', sPropDelim, sValueDelim, bNoOverwrite, bRecurse, bOwned), sString, bOwned, TRUE);

	sString = cstr(sString);
	sPropDelim = cstr(sPropDelim) || a;
	sValueDelim = cstr(sValueDelim) || eq;

	if (!sString) return me;

	firstChar = charAt(sString, 0);

	if (sPropDelim != q && sValueDelim != q && firstChar == q || firstChar == sPropDelim) sString = subStr(sString, 1);

	pairs = sString.split(sPropDelim);
	cnt = pairs[LEN];
	idx = 0;
	while (cnt--)
	{
		sTemp = pairs[idx++];
		added =
		doAdd = FALSE;
		if (sTemp) {
			nv = sTemp.split(sValueDelim);
			len = nv[LEN];
			if (len > 2) {
				nm = ues(nv[0]);
				nv.shift();

				if (bRecurse) {
					/* Its possible that someone screws up and doesn't have a value encoded properly and but have multiple delimiters
                    * As if recursion was going to take place. So here we know that's the case and try to handle it if we can detect
                    * the end points as well
                   */

					sTemp2 = nm + sValueDelim;
					idx2 = idxOf(sString, sTemp2);
					len = sTemp2[LEN];
					sTemp3 = subStr(sString, idx2 + len);
					sTemp2 = sPropDelim + sPropDelim;
					len2 = sTemp2[LEN];
					idx3 = idxOf(sTemp3, sTemp2);
					if (idx3 != -1) {
						sTemp3 = sString.substr(idx2 + len, idx3 + len2);
						obj = new ParamHash(sTemp3, sPropDelim, sValueDelim, bNoOverwrite, bRecurse);
						sTemp3 = '';
						len = 0;
						for (sTemp3 in obj) {len++;}

						if (len > 0) idx += len - 1;
						sTemp = obj;
					} else {
						sTemp = ues(nv.join(sValueDelim));
					}

				} else {
					sTemp = ues(nv.join(sValueDelim));
				}
				doAdd = TRUE;
			} else if (len == 2) {
				nm = ues(nv[0]);
				sTemp = ues(nv[1]);
				doAdd = TRUE;
			}
			if (doAdd) {
				if (bNoOverwrite) {
					if (!(nm in me)) {
						me[nm] = sTemp;
						added = TRUE;
					}
				} else {
					/*
             * if we get a duplicate key, convert the current
             * key / value pair into an array the first time
             * and add to that array from there on
            */
					if (nm in me) {
						obj = me[nm];
						if (!obj.push) {
							me[nm] = [obj, sTemp];
						} else {
							obj.push(sTemp);
						}
						added = TRUE;
					} else {
						me[nm] = sTemp;
						added = TRUE;
					}
				}
				if (bRecurse && added && nm && sTemp && typeof sTemp != TYPE_OBJ && (idxOf(sTemp, sPropDelim) >= 0 || idxOf(sTemp, sValueDelim) >= 0)) {
					me[nm] = new ParamHash(sTemp, sPropDelim, sValueDelim, bNoOverwrite, bRecurse, bOwned);
				}
			}
		}
	}
}

ParamHashProto = ParamHash[PROTO];

function ParamHashArrayItemInfo(p, i)
{
	var me = this;

	me.p = p;
	me.i = i;
}

/** @ignore */
function _param_hash_tostring(sPropDelim, sValueDelim, bOnlyValidValues, escapeProp, dontEscapeValue)
{
	var prop,buffer = [],me = this,idx = 0,props,propAry,propAryKey,propAryIdx,itemType,item,len;

	sPropDelim = sPropDelim || a;
	sValueDelim = sValueDelim || eq;
	props = keys(me);
	bOnlyValidValues = bOnlyValidValues !== false;

	if (props && props[LEN]) {
		/*jsl:ignore*/
		while (prop = props[idx++])
		/*jsl:end*/
		{
			if (typeof prop === TYPE_OBJ && prop && prop instanceof ParamHashArrayItemInfo) {
				/*
                                                                                     * props is orginally a list of keys in this object, so an array of strings
                                                                                     * but if the value of a prop is an array we want to handle that case
                                                                                     * below we'll construct a temporary object which in turn we'll add/store
                                                                                     * in this given list, and then handle those
                                                                                    */

				propAryKey = prop.p;
				propAryIdx = prop.i;
				propAry = me[propAryKey];
				if (propAry && isAry(propAry)) {
					item = propAry[propAryIdx];
					prop = propAryKey;
				} else {
					continue;
				}
			} else {
				item = me[prop];
			}
			itemType = typeof item;

			if (itemType == TYPE_FUNC) continue;
			if (isAry(item)) {
				/*
                      * if the item is an array, then add additional entries to our list of props to
                      * loop through, one for each index in the array, above we'll check for a specific
                      * object item signature for said prop
                      *
                     */
				len = item[LEN];
				propAry = new Array(len);

				for (propAryIdx = 0; propAryIdx < len; propAryIdx++)
				{
					propAry[propAryIdx] = new ParamHashArrayItemInfo(prop, propAryIdx);
				}

				/* insert the repeated items into our props list from the current index
       * as opposed to pushing onto the end
      */

				propAry.unshift(0); //2nd arg of splice is delete count, which is always 0
				propAry.unshift(idx); //1st arg of splice whish is our starting point, which is current idx + 1 of props
				props.splice.apply(props, propAry);
				continue;
			}
			if (itemType == TYPE_OBJ && item) {
				/*
                                       * ideally i'd like a better solution here, but there's really nothing
                                       * that will work 100% of the time any better than this. . .
                                      */

				if (item.tagName || item.nodeType) {
					item = "#node";
				} else {
					item = _param_hash_tostring.call(item, sPropDelim, sValueDelim, bOnlyValidValues, escapeProp, dontEscapeValue);
				}
			}
			if (escapeProp) prop = es(prop);
			if (!dontEscapeValue) item = es(item);

			if (!(itemType === TYPE_UNDEF && bOnlyValidValues)) buffer.push(prop, sValueDelim, item, sPropDelim);
		}
	}

	len = buffer[LEN];
	if (len) buffer[len - 1] = '';
	return cstr(buffer);
}

/**
   * Converts a ParamHash object back into a string using the property and value delimiters specifed (defaults to "&" and "=").
   * Again this method works recursively.  If an object is found as a property, it will convert that object into a ParamHash string
   * and then escape it. Note also that this class's valueOf method is equal to this method.
   *
   * @name fitt.ParamHash#toString
   * @function
   * @param {String} sPropDelim  The substring delimiter used to seperate properties. Default is "&".
   * @param {String} sValueDelim  The substring delimited used to seperate values.  Default is "=".
   * @param {Boolean} bOnlyValidValues If true, will prevent undefined values from being ouput. Default is true.
   * @return {String} the encoded string representation of the object.
   *
  */
ParamHashProto.toString = ParamHashProto.valueOf = _param_hash_tostring;

/* we don't care if it's old-school and doesn't support freezing */
try {fitt.freeze(ParamHash[PROTO]);} catch (e) {};

exp.ParamHash = ParamHash;

if (typeof module !== TYPE_UNDEF) {
	module.exports = ParamHash;
}

fitt.ns("fitt.ParamHash", ParamHash);


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-paramhash/index.js
// module id = 756
// module chunks = 0